import React, { Component } from 'react';
import Loading from '../../Loading.js'
import Modal from 'react-modal';
import ControlMessageNew from './ControlMessageNew.js';
import { getContacts } from '../../../Api/ExtranetActions.js'
import { getTranslation } from '../../../Utilities/GetTranslation.js'
import { getCreateMsgTitle } from '../../../Utilities/SnsExtranetFunctions.js';

class ExtranetContacts extends Component {
    constructor(props) {
        super(props);

        this.state = {}

        this.openMessageBox = this.openMessageBox.bind(this);
        this.closeMessageBox = this.closeMessageBox.bind(this);
    }

    componentWillMount() {
        this.loadData();
    }

    loadData() {
        getContacts((data) => {
            this.setState({
                contacts: data
            });
        });
    }

    openMessageBox(prlId) {
        this.setState({
            prlId: prlId,
            openMessageBox: true
        });
    }

    closeMessageBox() {
        this.setState({
            prlId: null,
            openMessageBox: false
        });
    }

    render() {
        if (this.state.contacts == null) {
            return (
                <Loading/>
            );
        }

        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="ebadge">
                            <div dangerouslySetInnerHTML={{ __html: this.props.content == null ? "" : this.props.content[0]}} />
                            <ul className="tiles">
                                {
                                    this.state.contacts.map((contact) =>
                                        <li key={contact.seqPers}>
                                            <div>
                                                <div style={{backgroundImage: contact.fotoUrl == null ? "" : "url('" + contact.fotoUrl + "')"}}>
                                                    &nbsp;
                                                </div>
                                            </div>
                                            <div>
                                                <h3>{contact.name + " " + contact.firstName}</h3>
                                                {
                                                    contact.telephone == null ? "" : <span><span>{getTranslation("sns.general.tel")}</span><span>{contact.telephone}</span></span>
                                                }
                                                {
                                                    contact.mobile == null ? "" : <span><span>{getTranslation("sns.general.gsm")}</span><span>{contact.mobile}</span></span>
                                                }
                                                {
                                                    contact.email == null ? "" : <span><span>{getTranslation("sns.general.email")}</span><a href={"mailto:" + contact.email}>{contact.email}</a></span>
                                                }
                                                <div className="feedbackButton">
                                                    <button type="button" className="FormButton btn btn-primary btn-sm" onClick={() => this.openMessageBox(contact.seqPers)}>
                                                        <i className="fa fa-pencil" aria-hidden="true"></i>{getCreateMsgTitle(null, null)}
                                                    </button>                                                    
                                                </div>
                                            </div>
                                        </li>
                                    )
                                }
                            </ul>
                            <div dangerouslySetInnerHTML={{ __html: this.props.content == null ? "" : this.props.content[1]}} />
                        </div>
                    </div>
                </div>
                <Modal
                    isOpen={this.state.openMessageBox}
                    onRequestClose={this.closeMessageBox}
                    className="ReactModal"
                    overlayClassName="ReactModalOverlay"                    
                >
                    <ControlMessageNew
                        contactId={this.state.prlId} 
                        onRequestClose={this.closeMessageBox} />
                </Modal>                
            </div>
        );
    }
}

export default ExtranetContacts;


// WEBPACK FOOTER //
// ./src/Components/Extranet/Pages/ExtranetContacts.js